import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { Strings } from "src/modules/utils/shared/strings";
import { AdminPageDefinition } from '../../models/admin-page-definition.model';
import { FeatureModuleService } from '../../services/feature-module.service';
import { Arrays } from 'src/modules/utils/shared/arrays';
import { EditGlobalEMailTemplatesComponent } from '../edit-global-email-templates.component/edit-global-email-templates.component';
import { EditGeneralUsersComponent } from '../edit-general-users/edit-general-users.component';
import { EditGeneralUserGroupsComponent } from '../edit-general-user-groups/edit-general-user-groups.component';
import { EditGeneralCompaniesComponent } from '../edit-general-companies/edit-general-companies.component';

@Component({
    selector: 'app-general-admin',
    templateUrl: './general-admin.component.html',
    styleUrl: './general-admin.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GeneralAdminComponent extends ComponentView {

    featureModuleService = inject(FeatureModuleService);

    pages: AdminPageDefinition[] = [];

    async initParams(): Promise<boolean> {
        this.fullScreenComponent = false;
        this.pages = [];
        if (this.app.mainConfig.useAdminUsers) {
            this.pages.push(EditGeneralUsersComponent.staticDefinition.getAdminPage());
        }
        if (this.app.mainConfig.useAdminUserGroups) {
            this.pages.push(EditGeneralUserGroupsComponent.staticDefinition.getAdminPage());
        }
        if (this.app.mainConfig.useAdminCompanies) {
            this.pages.push(EditGeneralCompaniesComponent.staticDefinition.getAdminPage());
        }
        if (this.app.mainConfig.useGlobalEMailTemplates) {
            this.pages.push(EditGlobalEMailTemplatesComponent.staticDefinition.getAdminPage());
        }
        for (let def of this.app.mainConfig.genericObjectDefinitions ?? []) {
            this.pages.push(new AdminPageDefinition(def.title, "", Strings.def(def.icon, "fas fa-cog"), def.singleton ? 
                ["/base2", "admin", "generic-edit", def.scope, def.id, "0"] :
                ["/base2", "admin", "generic-list", def.scope, def.id]));
        }

        this.pages = [...this.pages, ...this.featureModuleService.getAdminPages()];

        this.updateNavigation(null, [
            { label: "Administration", routerLink: ["/base2", "admin"] }
        ]);

        return Promise.resolve(true);
    }

    getCategories(): string[] {
        return Arrays.getUnique(this.pages.map(p => p.category).filter(c => c != null));
    }

}
